"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _production, _staging;

// Adobe Properties
var TELUSGLOBAL = 'telusglobal'; // 1. Telus Global

var MYTELUS = 'mytelus'; // 2. MyTelus

var tagManagers = {
  production: (_production = {}, (0, _defineProperty2["default"])(_production, TELUSGLOBAL, 'https://assets.adobedtm.com/launch-EN3a616363ba5741cbbdbab4982624983c.min.js'), (0, _defineProperty2["default"])(_production, MYTELUS, 'https://assets.adobedtm.com/launch-EN65f579f00cb04596bfa8bad1911ad8fa.min.js'), _production),
  staging: (_staging = {}, (0, _defineProperty2["default"])(_staging, TELUSGLOBAL, 'https://assets.adobedtm.com/launch-EN9808d87e565240b8b540732e616c48dc-staging.min.js'), (0, _defineProperty2["default"])(_staging, MYTELUS, 'https://assets.adobedtm.com/launch-ENdd4142b4bbfc4721982dd14bc0f2c424-staging.min.js'), _staging)
};

var getTagManagerScriptPath = function getTagManagerScriptPath(environment) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TELUSGLOBAL;
  return (tagManagers[environment] || {})[property] || 'data:text/javascript;base64,';
};

module.exports = getTagManagerScriptPath;